import { Image } from "@mantine/core";
import { useEffect, useState } from "react";

export const FilePreview = ({ file }: { file: File }) => {
  const [url, setUrl] = useState<string | undefined>();

  useEffect(() => {
    if (!url) {
      const url = URL.createObjectURL(file);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setUrl(url);
    }

    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [file, url]);

  return <Image w="200" h="200" src={url} alt={file.name} />;
};
